import '@prm/prm-chunks';
import '@/assets/styles/index.scss';
import '@multiTheme/assets/styles/multiIcons.css';
import '@prm/assets/styles/prmIcons.css';
import '@prm/assets/styles/prm.scss';

import { rehydrateMarks } from 'react-imported-component';

void rehydrateMarks();

void Promise.resolve().then(() =>
    Promise.resolve().then(() => {
        void import('./prmClient');
    })
);
